import React, { Component } from 'react';
import{ Link } from 'react-router-dom';

class NotFound extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="full-div">
                <div className="hero-min">
                    <div className="spacer"></div>
                    <div className="hero-min-topic">
                        <h2>Page not found</h2>
                        <p>
                            . <br/><br/><br/>
                        </p>
                    </div>
                </div>
                <div className="container">
                    <div className="hero-align un-margin-new row">
                        <div className="col-md-6">
                            <div className="inner-align-flex-col">
                                <div className="why-img show-small">
                                    <img src={require("./../images/not-found.png")} width="100%" alt=""/>
                                </div>
                                <div>
                                    <p>
                                        The page you have requested does not exist.   
                                    </p>
                                    <Link to="/">Back to home</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="hero-image2">
                                <img src={require("./../images/not-found.png")} width="100%" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         );
    }
    componentDidMount(){
        window.scrollTo(0, 0)
    }
}
 
export default NotFound;